import NotInterestedIcon from '@mui/icons-material/NotInterested';
import RvHookupIcon from '@mui/icons-material/RvHookup';
import * as React from 'react';
import { memo } from 'react';

import { FlightTurnaroundDto } from '../../../../../../../backend';
import { IataIcao } from '../../../../../../IataIcao/IataIcao';
import { getTurnaroundActualOccupation } from '../../../../RmsContent.utils';
import { ganttOneMinuteInMilliSeconds } from '../../../gantt.constants';
import {
    StyledControlIconBox,
    StyledTurnaroundAcTypeBox,
    StyledTurnaroundAdesAdepBox,
    StyledTurnaroundDataBox,
} from './TurnaroundZoneData.style';

export const TurnaroundZoneData = memo(function TurnaroundZoneData({
    turnaround,
}: {
    turnaround: FlightTurnaroundDto;
}) {
    const turnaroundOccupation = getTurnaroundActualOccupation(turnaround);

    if (!turnaroundOccupation) {
        return null;
    }

    return (
        <StyledTurnaroundDataBox>
            {turnaroundOccupation.occupationEnd?.time - turnaroundOccupation.occupationStart?.time >=
            20 * ganttOneMinuteInMilliSeconds ? (
                <>
                    <StyledTurnaroundAdesAdepBox justifyContent={'start'}>
                        {turnaround?.considerArrivalFlight && (
                            <>
                                <IataIcao
                                    iata={turnaround?.arrivalFlight?.adepIata}
                                    icao={turnaround?.arrivalFlight?.adepIcao}
                                />
                                {turnaround?.arrivalFlight?.arrivalControlled && (
                                    <StyledControlIconBox>
                                        <NotInterestedIcon sx={{ width: '12px', height: '12px' }} />
                                    </StyledControlIconBox>
                                )}
                            </>
                        )}
                    </StyledTurnaroundAdesAdepBox>

                    <StyledTurnaroundAcTypeBox>
                        {turnaround?.arrivalFlight ? (
                            <IataIcao
                                iata={turnaround.arrivalFlight.acTypeIata}
                                icao={turnaround.arrivalFlight.acTypeIcao}
                            />
                        ) : (
                            <IataIcao
                                iata={turnaround?.departureFlight?.acTypeIata}
                                icao={turnaround?.departureFlight?.acTypeIcao}
                            />
                        )}
                        {turnaround?.arrivalFlight?.towings?.length > 0 && (
                            <RvHookupIcon
                                color={'success'}
                                sx={{ width: '12px', height: '12px', marginBottom: '2px' }}
                            />
                        )}
                    </StyledTurnaroundAcTypeBox>
                    <StyledTurnaroundAdesAdepBox justifyContent={'end'}>
                        {turnaround?.considerDepartureFlight && (
                            <>
                                {turnaround?.departureFlight?.departureControlled && (
                                    <StyledControlIconBox>
                                        <NotInterestedIcon sx={{ width: '12px', height: '12px' }} />
                                    </StyledControlIconBox>
                                )}
                                <IataIcao
                                    iata={turnaround?.departureFlight?.adesIata}
                                    icao={turnaround?.departureFlight?.adesIcao}
                                />
                            </>
                        )}
                    </StyledTurnaroundAdesAdepBox>
                </>
            ) : (
                <>
                    {turnaround?.arrivalFlight?.towings?.length > 0 && (
                        <div style={{ width: '100%', textAlign: 'center', height: '13px' }}>
                            <RvHookupIcon
                                color={'success'}
                                sx={{ width: '12px', height: '12px', marginBottom: '2px' }}
                            />
                        </div>
                    )}
                </>
            )}
        </StyledTurnaroundDataBox>
    );
});
